import type { AppIconProps } from "../IconTypes";

export const SaveIcon: React.FC<AppIconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 4C2 2.89543 2.89543 2 4 2H11.7962C12.0846 2 12.3589 2.12448 12.5488 2.3415L13.7526 3.71723C13.9121 3.89952 14 4.13351 14 4.37574V12C14 13.1046 13.1046 14 12 14H4C2.89543 14 2 13.1046 2 12V4Z"
        stroke="#59C69E"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 2H10.5V5H5.5V2Z"
        stroke="#59C69E"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 9.5C10 9.76264 9.94827 10.0227 9.84776 10.2654C9.74725 10.508 9.59993 10.7285 9.41421 10.9142C9.2285 11.0999 9.00802 11.2472 8.76537 11.3478C8.52272 11.4483 8.26264 11.5 8 11.5C7.73736 11.5 7.47728 11.4483 7.23463 11.3478C6.99198 11.2472 6.7715 11.0999 6.58579 10.9142C6.40007 10.7285 6.25275 10.508 6.15224 10.2654C6.05173 10.0227 6 9.76264 6 9.5C6 8.96957 6.21071 8.46086 6.58579 8.08579C6.96086 7.71071 7.46957 7.5 8 7.5C8.53043 7.5 9.03914 7.71071 9.41421 8.08579C9.78929 8.46086 10 8.96957 10 9.5Z"
        stroke="#59C69E"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
